'use client';

import React from 'react';
import { ChipiProvider as ClientChipiProvider } from '../app-router/client/ChipiProvider';

export interface ChipiProviderProps {
  children: React.ReactNode;
  apiPublicKey?: string;
  environment?: 'development' | 'production';
}

/**
 * This is a compatibility layer that provides a client-only ChipiProvider.
 * This is used when the conditional export resolves to the client boundary.
 */
export function ChipiProvider({ 
  children, 
  apiPublicKey,
  environment = 'development' 
}: ChipiProviderProps) {
  // For client-only usage, allow apiPublicKey to be passed as prop
  // or read from environment
  const finalApiPublicKey = apiPublicKey || process.env.NEXT_PUBLIC_CHIPI_API_KEY;

  if (!finalApiPublicKey) {
    throw new Error(
      'Missing NEXT_PUBLIC_CHIPI_API_KEY environment variable or apiPublicKey prop. Please provide one.'
    );
  }

  return (
    <ClientChipiProvider 
      apiPublicKey={finalApiPublicKey} 
      environment={environment}
    >
      {children}
    </ClientChipiProvider>
  );
}
